let apiEndpoint = '';
const hostname = window.location.hostname;
const isLive = window.location.hostname !== 'localhost';
if (hostname === 'v2reports.group8a.com') {
    // if (hostname === 'analytics.group8a.com') {
    apiEndpoint = 'https://apireports.group8a.com';
}
else if (hostname === 'localhost') {
    apiEndpoint = 'http://localhost:3002';
}
export { apiEndpoint, isLive };
